import { render, staticRenderFns } from "./editPerfect.vue?vue&type=template&id=68768480&scoped=true&"
import script from "./editPerfect.vue?vue&type=script&lang=js&"
export * from "./editPerfect.vue?vue&type=script&lang=js&"
import style0 from "./editPerfect.vue?vue&type=style&index=0&id=68768480&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68768480",
  null
  
)

export default component.exports